'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.dayAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/dayAfter.js
// module id = 659
// module chunks = 0